module.exports = __webpack_public_path__ + "assets/img/index-partner7.d020556d.jpg";